import { render, staticRenderFns } from "./AbandonedCartPreviewModal.vue?vue&type=template&id=90368f2a&scoped=true"
import script from "./AbandonedCartPreviewModal.vue?vue&type=script&lang=js"
export * from "./AbandonedCartPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./AbandonedCartPreviewModal.vue?vue&type=style&index=0&id=90368f2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90368f2a",
  null
  
)

export default component.exports